<template>
  <div>
    <beast-header/>
    <div class="container">
      <beast-search-box v-on:searchEnded="updateSearch"
                        :query="searchQuery"/>
      <beast-packages-list
        v-on:keywordSearch="updateSearch"
        v-on:updateUrl="updateURL"
        :toSearchQuery="searchQuery"
        :page="page"
        :size="size"/>
    </div>
    <beast-footer/>
  </div>
</template>

<script>
import BeastHeader from "../components/header/BeastHeader.vue";
import BeastFooter from "../components/footer/BeastFooter.vue";
import BeastPackagesList from "../components/packages/BeastPackagesList.vue";
import BeastSearchBox from "../components/packages/BeastSearchBox.vue";

export default {
  name: "Search",
  components: {
    BeastSearchBox, BeastPackagesList, BeastFooter, BeastHeader
  },
  computed: {
    searchQuery() {
      return this.$route.query.query || "";
    },
    page() {
      return parseInt(this.$route.query.page) || 1;
    },
    size() {
      return parseInt(this.$route.query.size) || 10;
    }
  },
  methods: {
    updateURL(query) {
      this.$router.replace({
        name: "search",
        query
      });
      this.updateTitle(query);
    },
    updateSearch(query) {
      this.$router.replace({
        name: "search",
        query: {
          query,
          page: 1
        }
      });
    },
    updateTitle(query) {
      this.setTitle(query.query.indexOf("keywords") >= 0
        ? "Keyword Search"
        : "Package Search");
    }
  }
};
</script>
